export const totalValueDetails = {
  200: [
    { name: 'eero 6+ Router', price: 139 },
    { name: 'Expert installation', price: 100 },
    { name: 'Bank Auto Pay', price: 120 },
  ],
  500: [
    { name: 'eero 6+ Router', price: 139 },
    { name: 'Expert installation', price: 100 },
    { name: 'Bank Auto Pay', price: 120 },
  ],
  1000: [
    { name: 'eero Pro 6e router', price: 249 },
    { name: 'Expert installation', price: 100 },
    { name: 'Bank Auto Pay', price: 120 },
  ],
  2000: [
    { name: 'eero Pro 6e router', price: 249 },
    { name: <>Visa<sup>&reg;</sup> Reward Card</>, price: 200},
    { name: 'Expert installation', price: 100 },
    { name: 'Bank Auto Pay', price: 120 },
  ],
  5000: [
    { name: 'eero Max 7 router', price: 599 },
    { name: 'Expert installation', price: 100 },
    { name: 'Bank Auto Pay', price: 120 },
  ],
  7000: [
    { name: 'eero Max 7 router', price: 599 },
    { name: 'Whole-Home Wi-Fi', price: 120 },
    { name: 'My Premium Tech Pro', price: 120 },
    { name: 'Wi-Fi Security', price: 60 },
    { name: 'Expert installation', price: 100 },
    { name: 'Bank Auto Pay', price: 120 },
  ]
};
